module.exports = __webpack_public_path__ + "static/media/banner.8db259d6.jpg";